import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import AudioPlayer from 'react-h5-audio-player';
import { fetchSignedUrlByType } from '../utils/fetchSignedUrlByFolderV2';
import 'react-h5-audio-player/lib/styles.css';
import '../styles/rhap.css';

const AaiAudioPlayerMin = React.memo(({ folderName, sample, requestType, showHeader, autoPlay, onEnded, customStyles }) => {
  const userId = useSelector((state) => state.user.profile).data.userId;
  const [signedUrl, setSignedUrl] = useState('');
  const playerRef = useRef(null); // Ref to control the audio player

  let fileName = sample?.voiceSnippet?.fileName || "";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const signedurl = await fetchSignedUrlByType({
          requestType: requestType, //'FOLDER',
          userId: userId,
          folderName: folderName,
          fileName: fileName
        });

        setSignedUrl(signedurl);
      } catch (error) {
        console.error('Error fetching signed URL:', error.message);
      }
    };

    if (fileName === "") {
      setSignedUrl("");
      return;
    }
    fetchData();
  }, [userId, folderName, fileName]);

  // Handle visibility change to stop playback when the page loses focus
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden && playerRef.current) {
        playerRef.current.audio.current.pause(); // Stop playback
        playerRef.current.audio.current.currentTime = 0; // Reset to the beginning
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // Handle parent container click to stop playback
  const handleParentClick = () => {
    if (playerRef.current) {
      playerRef.current.audio.current.pause(); // Stop playback
      playerRef.current.audio.current.currentTime = 0; // Reset to the beginning
    }
  };

  return (
    <div
      className='aai_audio_player_container'
      onClick={handleParentClick} // Stop playback on parent click
    >
      {signedUrl !== '' && (
        <div className='aai_player_container' style={{
          padding: customStyles?.padding || "0px 10px 10px 10px",
          ...customStyles
        }}>
          <AudioPlayer
            ref={playerRef} // Attach ref to the AudioPlayer
            header={showHeader ? "FILENAME: " + sample.voiceSnippet.fileName : ""}
            autoPlay={autoPlay}
            layout="horizontal-reverse"
            customAdditionalControls={[]}
            showJumpControls={false}
            customVolumeControls={[]}
            src={signedUrl}
            onEnded={onEnded}
          />
        </div>
      )}
    </div>
  );
});

export default AaiAudioPlayerMin;
